import type { LocaleMessages } from "./locale.d";

const enUS: LocaleMessages = {
  mainNav: {
    resumeButtonLabel: "My Resume",
  },
  downloadResume: {
    buttonLabel: "Download Resume (PDF)",
    shareLabel: "Share",
    recruiterCta: "Hey recruiter! Grab my resume \u{1F447}",
  },
  resumePrint: {
    summaryHeading: "Summary",
    experienceHeading: "Experience",
    educationHeading: "Education",
    coursesHeading: "Courses",
    languagesHeading: "Languages",
    skillsHeading: "Skills",
    generatedOnLabel: "Generated on",
    documentSuffix: "Resume",
  },
  skillsPage: {
    pageTitle: "Skills & Learning",
    pageDescription:
      "An overview of my technical skills, expertise tiers, and learning background — from formal education to self-directed study.",
    skillsSectionHeading: "Tools",
    skillsSectionSubheading:
      "Technical tools grouped by expertise tier. Years of experience derived from active use since first adoption date.",
    learningSectionHeading: "Learning",
    learningSectionSubheading:
      "Formal education, courses, and books that have shaped my technical foundation.",
    tabs: {
      tools: "Tools",
      learning: "Learning",
    },
    tiers: {
      expert: "Expert",
      proficient: "Proficient",
      familiar: "Familiar",
    },
    tierDescriptions: {
      expert: "expertise >= 4",
      proficient: "expertise 2–3",
      familiar: "expertise <= 1",
    },
    filterAll: "All",
    projectsExpandLabel: "Used in",
    projectsCount: (count: number) =>
      count === 1 ? "1 project" : `${count} projects`,
    yearsDisplay: {
      lessThanOneYear: "< 1 yr",
      years: (n: number) => `${n} yr${n === 1 ? "" : "s"}`,
    },
    noSkillsInCategory: "No skills found in this category.",
  },
  learningPage: {
    educationHeading: "Education",
    educationSubheading: "Formal academic background and certifications.",
    coursesHeading: "Courses",
    booksHeading: "Books",
    interestsHeading: "Professional Interests",
    inProgressLabel: "In Progress",
    completedLabel: "Completed",
    attendedLabel: "Attended",
    viewCertificateLabel: "View certificate",
    viewCourseLabel: "View course",
    noEducationItems: "No education entries found.",
    noCoursesItems: "No courses listed yet.",
    noBooksItems: "No books listed yet.",
    noInterestsItems: "No professional interests listed yet.",
    officialWebsiteLabel: "Official Website",
  },
};

export default enUS;
